export function MainMenu(Collapse) {
  // DOM
  const mainMenu = document.getElementById('main-menu');
  const isSimple = document.querySelector('.header-nav--simple');
  const navbar = document.querySelector('.navbar');
  const toggler = document.querySelector('.navbar-toggler');
  // const hero = document.querySelector('.hero');

  const breakpoint = 992;

  let menu;

  // Methods
  const init = () => {
    if (isSimple) {
      _addSimpleListeners();
    } else {
      if (!mainMenu) return false;
      console.log('INIT');

      menu = new Collapse(mainMenu, {
        toggle: false,
      });

      _addListeners();
      _checkWindow();
    }
  };

  const _addSimpleListeners = () => {
    window.addEventListener('scroll', (e) => {
      _checkMenuScroll();
    });
  };

  const _addListeners = () => {
    window.addEventListener('resize', (e) => {
      _checkWindow();
    });
  };

  const _checkWindow = (e) => {
    if (window.innerWidth < breakpoint) {
      _initMobile();
    } else {
      _initDesktop();
    }
  };

  const _initMobile = () => {
    _checkMenuScroll();

    navbar.classList.remove('navbar--submenu-open');

    mainMenu.addEventListener('show.bs.collapse', _handleShowCollapse, false);
    mainMenu.addEventListener('hide.bs.collapse', _handleHideCollapse, false);

    window.addEventListener('scroll', (e) => {
      _checkMenuScroll();
    });
  };

  const _initDesktop = () => {
    _checkMenuScroll();
    menu.hide();

    document.body.classList.remove('menu-open');

    mainMenu.removeEventListener('show.bs.collapse', _handleShowCollapse, false);
    mainMenu.removeEventListener('hide.bs.collapse', _handleHideCollapse, false);

    window.addEventListener('scroll', (e) => {
      _checkMenuScroll();
    });
  };

  const _checkMenuScroll = () => {
    // page has no hero
    if (window.scrollY < 150) {
      navbar.classList.remove('navbar--sticky');
    } else {
      navbar.classList.add('navbar--sticky');
    }
  };

  const _handleShowCollapse = (e) => {
    document.body.classList.add('menu-open');
    toggler.classList.add('is-active');
  };

  const _handleHideCollapse = (e) => {
    document.body.classList.remove('menu-open');
    toggler.classList.remove('is-active');
  };

  return { init };
}
